import React, { Component } from 'react';

class Home extends Component {
  render() {
    return <div className="para" />;
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/views/Home.js